var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-content main-index" }, [
      _c("h3", { staticClass: "container content-title" }, [
        _vm._v("为什么选择我们？")
      ]),
      _c("h5", { staticClass: "container lines" }),
      _c("h5", { staticClass: "container tips" }, [
        _vm._v(
          "我们为合作伙伴提供全面的客户-订单-财务-仓库解决方案，智能化仓储管理，根据市场需求系统迭代创新速度快，通过一次次的迭代，使系统更适合企业发展，帮助合作伙伴牢牢抓住客户资源。"
        )
      ]),
      _c("div", { staticClass: "container content-body" }, [
        _c("div", { staticClass: "cell" }, [
          _c("div", [
            _c("img", {
              attrs: {
                src: require("static/images/cooperation/banner/Q1.png"),
                alt: ""
              }
            }),
            _c("p", [_vm._v("提供全面的一站式解决方案")])
          ]),
          _c("div", [
            _c("img", {
              attrs: {
                src: require("static/images/cooperation/banner/Q3.png"),
                alt: ""
              }
            }),
            _c("p", [_vm._v("智能化仓储管理")])
          ]),
          _c("div", [
            _c("img", {
              attrs: {
                src: require("static/images/cooperation/banner/Q2.png"),
                alt: ""
              }
            }),
            _c("p", [_vm._v("不断创新，助力企业发展")])
          ])
        ]),
        _c("div", { staticClass: "btns" }, [
          _c(
            "a",
            {
              staticClass: "title",
              attrs: {
                href: "https://www.xinminghui.com/saas-apply",
                target: "_blank"
              }
            },
            [_vm._v("立即合作")]
          )
        ])
      ]),
      _c("div", { staticClass: "bgm" }, [
        _c("h3", { staticClass: "container content-title" }, [
          _vm._v("客户案例")
        ]),
        _c("h5", { staticClass: "container lines" }),
        _c("h5", { staticClass: "container tips" }, [
          _vm._v("他们选择了易安捷 专业让我们一起合作")
        ]),
        _c("div", { staticClass: "container content-body" }, [
          _c("div", { staticClass: "cell comp" }, [
            _c("div", [
              _c("div", { staticClass: "img-box" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://yqg.eainger.com/",
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("static/images/cooperation/banner/L5.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
              _c("p", [_vm._v("益海嘉里")])
            ]),
            _c("div", [
              _c("div", { staticClass: "img-box" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://bofety.eainger.com/",
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("static/images/cooperation/banner/L6.jpg"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
              _c("p", [_vm._v("博富特")])
            ]),
            _c("div", [
              _c("div", { staticClass: "img-box" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "http://egou.shengquan.com:8088/",
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("static/images/cooperation/banner/L7.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
              _c("p", [_vm._v("圣泉集团")])
            ]),
            _c("div", [
              _c("div", { staticClass: "img-box" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "http://bochuan.eainger.com",
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("static/images/cooperation/banner/L8.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
              _c("p", [_vm._v("香驰控股")])
            ]),
            _c("div", [
              _c("div", { staticClass: "img-box" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "https://shichengsd.com/", target: "_blank" }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("static/images/cooperation/banner/L10.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
              _c("p", [_vm._v("仕程")])
            ]),
            _c("div", [
              _c("div", { staticClass: "img-box" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://xjxmh.eainger.com/",
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("static/images/cooperation/banner/L9.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
              _c("p", [_vm._v("新疆新明辉")])
            ]),
            _c("div", [
              _c("div", { staticClass: "img-box" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "https://sn.eainger.com", target: "_blank" }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("static/images/cooperation/banner/L11.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
              _c("p", [_vm._v("山东山能")])
            ]),
            _c("div", [
              _c("div", { staticClass: "img-box" }, [
                _c("img", {
                  attrs: {
                    src: require("static/images/cooperation/banner/L3.png"),
                    alt: ""
                  }
                })
              ]),
              _c("p", [_vm._v("天津双安劳保橡胶有限公司")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58debaf1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58debaf1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/cooperation/NewAfterSales.vue
// module id = lAVM
// module chunks = 0